@if (isVisible()) {
  <!--
  add a class to change the border color if isExpanded signal is true
  -->
  <section
    class="document-requirement-changes"
    data-testid="document-requirement-changes-section"
    [class.document-requirement-changes-active]="isExpanded()"
  >
    <button
      class="section-toggle"
      (click)="toggleSection()"
      [attr.aria-expanded]="isExpanded()"
      data-testid="document-requirement-changes-toggle"
    >
      <mat-icon class="chevron-icon" [class.chevron-expanded]="isExpanded()"
        >keyboard_arrow_right</mat-icon
      >
      <span class="section-title">Document Requirement Changes</span>
    </button>

    <div class="collapsible-content" [class.collapsed]="!isExpanded()">
      <div class="collapsible-inner">
        <p
          class="section-subtitle"
          data-testid="document-requirement-changes-subtitle"
        >
          This section shows the document type classification reviewed by the
          vendor during the quoting process. It details which documents were
          reclassified (from DTP to Non-DTP or vice versa) and which remained
          unchanged, along with the vendor's justification for any changes made.
        </p>

        <table
          class="reclassification-table"
          [class.reclassification-table--no-justification]="
            !showJustification()
          "
          data-testid="document-requirement-changes-table"
        >
          <thead>
            <tr>
              <th class="th-doc-name">Document Name</th>
              <th class="th-dtp">Desktop Publishing Requirements (DTP)</th>
            </tr>
          </thead>
          <tbody>
            @for (
              item of reclassificationItems();
              track item.documentName;
              let i = $index
            ) {
              <tr [attr.data-testid]="'document-requirement-changes-row-' + i">
                <td class="doc-name-cell">{{ item.documentName }}</td>
                <td
                  class="dtp-cell"
                  [attr.data-testid]="'document-requirement-changes-dtp-' + i"
                >
                  @if (item.isReclassified) {
                    <span
                      class="reclassified-indicator"
                      [attr.aria-label]="item.ariaLabel"
                    >
                      <span class="classification-label">{{
                        item.originalLabel
                      }}</span>
                      <mat-icon
                        class="arrow-icon"
                        [attr.data-testid]="
                          'document-requirement-changes-arrow-' + i
                        "
                        >arrow_forward</mat-icon
                      >
                      <span class="classification-label">{{
                        item.revisedLabel
                      }}</span>
                    </span>
                  } @else {
                    <span>{{ item.displayText }}</span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>

        @if (showJustification()) {
          <div
            class="justification-section"
            data-testid="document-requirement-changes-justification"
          >
            <h4 class="justification-heading">Details of vendor changes</h4>
            <p
              class="justification-text"
              data-testid="document-requirement-changes-justification-text"
            >
              {{ detail().changeJustificationDtp }}
            </p>
          </div>
        }
      </div>
    </div>
  </section>
}
